import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

let IP = environment.apiUrl;
let http_type = environment.apiType;

@Injectable({ providedIn: 'root' })
export class RequestService<T> {
  private datasetsUrl =
    http_type + '://' + IP + '/api/datasets/';
  private experimentsUrl =
    http_type + '://' + IP + '/api/experiments/';
  private samplesUrl =
    http_type + '://' + IP + '/api/samples/';
  private warningsUrl =
    http_type + '://' + IP + '/api/warnings/';
  private literatureUrl =
    http_type + '://' + IP + '/api/literature/compendium/';
  private literatureSamplesUrl = 
  http_type + '://' + IP + '/api/literature/samples/';

  constructor(private http: HttpClient) { }

  // GET REQUESTS==================================================================================

  getDataset(id: any): Observable<T> {
    let URL = this.datasetsUrl + id;
    return this.http.get<T>(URL, {
    }).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getExperiments(id: any): Observable<T> {
    let URL = this.experimentsUrl + id;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getSample(id: any): Observable<T> {
    let URL = this.samplesUrl + id;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getSensorDatasets(): Observable<T> {
    let URL = this.datasetsUrl + '?type=sensor';
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getBioDatasets(): Observable<T> {
    let URL = this.datasetsUrl + '?type=bio';
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getPysicoDatasets(): Observable<T> {
    let URL = this.datasetsUrl + '?type=physio';
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getLiteratureCompendiumDatasets(): Observable<T> {
    return this.http.get<T>( this.literatureUrl).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getLiteratureSamples(id: any): Observable<T> {
    let URL = this.literatureSamplesUrl + '?compendium_id=' + id;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getWarnings(): Observable<T> {
    return this.http.get<T>(this.warningsUrl).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  // POST REQUESTS==================================================================================

  postFile(formData) {
    return this.http.post(this.experimentsUrl, formData).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }
}
